import type { CustomFile } from '../types';

import toCustomFile from './toCustomFile';

// ----------------------------------------------------------------------------

function getDragEventFiles(evt: DragEvent): CustomFile[] {
    return Array.from(evt.dataTransfer?.files ?? [], (file): any => toCustomFile(file));
}

// ----------------------------------------------------------------------------

export default getDragEventFiles;
